import React from 'react';
import styles from './Enquiries.module.css';

const EnquiriesLoadingState = () => {
  return (
    <div className={styles.container}>
      <div className={styles.loadingState}>
        <div className={`${styles.skeleton} ${styles.skeletonHeader}`} />
        <div className={styles.skeletonCards}>
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
        </div>
        <div className={`${styles.skeleton} ${styles.skeletonTable}`} />
      </div>
    </div>
  );
};

export default EnquiriesLoadingState;